/**
 * Lightweight global event bus for "you just funded the pots" UX nudges.
 * Any successful wager API call should dispatch this so the navbar chip + any
 * other listeners can react.
 *
 * Usage in any wager handler:
 *   import { announcePotContribution } from '../utils/potContribution';
 *   const { data } = await axios.post(...);
 *   announcePotContribution(data?.pot_contribution);
 */
const EVENT_NAME = 'betohalics:pot-contribution';

export function announcePotContribution(contribution) {
    if (!contribution || !contribution.total_add || contribution.total_add <= 0) return;
    try {
        window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: contribution }));
    } catch { /* ignore */ }
}

export function onPotContribution(handler) {
    const fn = (e) => handler(e.detail);
    window.addEventListener(EVENT_NAME, fn);
    return () => window.removeEventListener(EVENT_NAME, fn);
}
